/**
 * @file: useAdaptiveContainerWidth.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useAsideContext } from '@euler/components/Aside';
import { useContainerLayout } from '@euler/components/layout/LayoutProvider';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { useWindowDimensions } from 'react-native';

export const useAdaptiveContainerWidth = (options?: {
  excludeLayoutContainer?: boolean;
}) => {
  const dimens = useWindowDimensions();
  const isMobile = useIsMobileLayout();
  const containerSize = useContainerLayout();
  const asideWidth = useAsideContext()?.width;
  if (asideWidth != null) {
    return asideWidth;
  }
  if (isMobile) {
    return dimens.width;
  }
  if (!options?.excludeLayoutContainer && containerSize?.width) {
    return containerSize.width;
  }
  return dimens.width;
};

export const useContainerWidth = () => {
  const dimens = useWindowDimensions();
  const containerSize = useContainerLayout();
  return containerSize?.width == null ? dimens.width : containerSize.width;
};

export const useContainerDimensions = () => {
  const dimens = useWindowDimensions();
  const containerSize = useContainerLayout();
  return containerSize ?? { width: dimens.width, height: dimens.height };
};

export const useLayoutContainerWidth = () => {
  const dimens = useWindowDimensions();
  const containerSize = useContainerLayout();
  const asideWidth = useAsideContext()?.width;
  return containerSize?.width ?? asideWidth ?? dimens.width;
};
